<template>
    <svg :viewBox="`0 0 ${W} ${H}`" preserveAspectRatio="none" style="display: block; width: 100%; height: 100%">
        <path :d="areaD" :fill="strokeColor" :fill-opacity="fillOpacity" />
        <path
            :d="lineD"
            fill="none"
            :stroke="strokeColor"
            :stroke-width="strokeWidth"
            stroke-linejoin="round"
            stroke-linecap="round"
        />
        <circle :cx="lastX" :cy="lastY" :r="dotRadius" :fill="strokeColor" />
    </svg>
</template>

<script>
import { CHART_PALETTE } from "../../utils/chartTheme.js";

export default {
    name: "SparkLineChart",
    props: {
        values: { type: Array, default: () => [] },
        color: { type: String, default: "" },
    },
    data() {
        return { W: 80, H: 28, P: 3 };
    },
    computed: {
        strokeColor() {
            return this.color || CHART_PALETTE.spark.default;
        },
        strokeWidth() {
            return 1.2;
        },
        fillOpacity() {
            return 0.08;
        },
        dotRadius() {
            return 2.2;
        },
        safeValues() {
            const v = (this.values || []).map(Number).filter(isFinite);
            return v.length >= 2 ? v : v.length === 1 ? [v[0], v[0]] : [0, 0];
        },
        coords() {
            const { W, H, P, safeValues: vals } = this;
            const n = vals.length;
            const max = Math.max(...vals);
            const min = Math.min(...vals);
            const span = max - min || 1;
            const iw = W - P * 2;
            const ih = H - P * 2;
            return vals.map((v, i) => ({
                x: P + (iw * i) / (n - 1),
                y: P + ih - ((v - min) / span) * ih,
            }));
        },
        lineD() {
            return this.coords.map((c, i) => `${i === 0 ? "M" : "L"}${c.x},${c.y}`).join(" ");
        },
        areaD() {
            const { coords: c, H, P } = this;
            const n = c.length;
            return `M${c[0].x},${H - P} ${c.map((p) => `L${p.x},${p.y}`).join(" ")} L${c[n - 1].x},${H - P} Z`;
        },
        lastX() {
            return this.coords[this.coords.length - 1]?.x ?? 0;
        },
        lastY() {
            return this.coords[this.coords.length - 1]?.y ?? 0;
        },
    },
};
</script>
